export default "__VITE_ASSET__7a521b07__"